﻿$.fn.dxCtrlBuilderEmailPageUndoRedo = function custom_dxCtrlBuilderEmailPageUndoRedo(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailpageundoredo dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailPageUndoRedo(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailPageUndoRedo = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var lstAction = [option.html]
    var idxCursor = lstAction.length - 1
    var dxBtUndo = null
    var dxBtRedo = null
    var $TdLib = null
    function mConstruit() {
        if (option.dxBtUndo) {
            dxBtUndo = option.dxBtUndo
            dxBtRedo = option.dxBtRedo
        } else {
            var $Table = $("<table/>").appendTo(container)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td/>").appendTo($Tr)
            dxBtUndo = $("<div style=''/>").appendTo($Td).dxCtrlButton({
                icon: "fas fa-rotate-left",
                hint: "Annuler",
                disabled: true,
                //onClick: function (e) {
                //    idxCursor -= 1
                //    option.onChangeAction(lstAction[idxCursor])
                //    mUpdateButton()
                //}
            }).dxCtrlButton("instance")
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td/>").appendTo($Tr)
            dxBtRedo = $("<div style=''/>").appendTo($Td).dxCtrlButton({
                icon: "fas fa-rotate-right",
                hint: "Rétablir",
                disabled: true,
                //onClick: function (e) {
                //    idxCursor += 1
                //    option.onChangeAction(lstAction[idxCursor])
                //    mUpdateButton()
                //}
            }).dxCtrlButton("instance")
        }

        dxBtUndo.option("onClick", function (e) {
            idxCursor -= 1
            option.onChangeAction(lstAction[idxCursor])
            mUpdateButton()
        })
        dxBtUndo.option("visible", true)
        dxBtUndo.mRempliCompteur(0)
        dxBtRedo.option("onClick", function (e) {
            idxCursor += 1
            option.onChangeAction(lstAction[idxCursor])
            mUpdateButton()
        })
        dxBtRedo.option("visible",true)
        dxBtRedo.mRempliCompteur(0)

        mUpdateButton()
    }

    this.mAddAction = function (html) {
        lstAction.splice(idxCursor + 1)
        lstAction.push(html)
        idxCursor = lstAction.length - 1
        mUpdateButton()
    }

    function mUpdateButton() {
        dxBtUndo.component().option("disabled", mGetNbUndo() == 0)
        dxBtUndo.mRempliCompteur(mGetNbUndo())
        dxBtRedo.component().option("disabled", mGetNbRedo() == 0)
        dxBtRedo.mRempliCompteur(mGetNbRedo())
        //$TdLib.text(lstAction[idxCursor])
    }
    function mGetNbUndo() {
        if (idxCursor == null || idxCursor == 0) { return 0 }
        else { return idxCursor }
    }
    function mGetNbRedo() {
        if (idxCursor == null || idxCursor == lstAction.length - 1) { return 0 }
        else { return lstAction.length - idxCursor - 1 }
    }
    this.element = function () { return container }

    mConstruit();

}